import { curryN, equals, length, pipe } from 'ramda';

import { fetchValue } from './util';

export default curryN(2, (len, value) =>
  pipe(fetchValue, length, equals(len))(value)
);
